import config from 'constants/config'
import { useWeddingGiftRegistryContext } from 'weddings/contexts/WeddingGiftRegistryContext'

function useIsOpenNewTabOfferClickEnabled(): boolean {
  const { isActive: isWeddingGiftRegistry } = useWeddingGiftRegistryContext()

  return config.OPEN_NEW_TAB_OFFER_CLICK && !isWeddingGiftRegistry
}

export default useIsOpenNewTabOfferClickEnabled
